<template>
  <PublicPage title="Assistance" lead="Un problème technique, une question sur les modules, un besoin particulier : contactez-moi.">
    <div class="topics">
      <section>
        <h2>Assistance technique</h2>
        <p>Rencontrez-vous des problèmes techniques ? Une erreur incompréhensible, un bug gênant ou un problème bloquant ? Ne restez pas seul face à ces difficultés, contactez-moi.</p>
      </section>
      <section>
        <h2>Questions sur les modules ?</h2>
        <p>Vous souhaitez en savoir plus sur l'un de nos modules ou même le tester ? N'hésitez pas à me contacter pour obtenir toutes les informations nécessaires.</p>
      </section>
      <section>
        <h2>Formation personnalisée</h2>
        <p>Bénéficiez d'une formation gratuite si besoin ! Destinée aux utilisateurs potentiels de l'application, cette formation vous permettra de maîtriser son utilisation en toute simplicité.</p>
      </section>
      <section>
        <h2>Développement de modules sur mesure</h2>
        <p>Vous avez des besoins spécifiques et souhaitez un module personnalisé ? Contactez-moi pour discuter de vos besoins et voir comment je peux vous aider.</p>
      </section>
    </div>

    <section class="contact" aria-labelledby="contact-title">
      <h2 id="contact-title">Comment me contacter&nbsp;?</h2>
      <ul>
        <li>
          <span class="way">LinkedIn</span>
          <a class="pub-link" href="https://www.linkedin.com/in/franck-besson-fr/">franck-besson-fr</a>
        </li>
        <li>
          <span class="way">Mail</span>
          <a class="pub-link hyperlink" href="mailto:contact@citrondigital.fr">contact@citrondigital.fr</a>
        </li>
        <li>
          <span class="way">Téléphone</span>
          <a class="pub-link hyperlink" href="tel:0614851819">+33 6 14 85 18 19</a>
        </li>
      </ul>
    </section>
  </PublicPage>
</template>

<script>
    import PublicPage from "@/components/public/PublicPage.vue";
    import {useHead} from "@vueuse/head";

    export default {
        name: 'AssistanceView',
        components: {PublicPage},
        mounted() {
        useHead({
          title: 'Assistance - Aide logiciel facturation électronique et gestion client',
          meta: [
            {
              name: 'description',
              content: 'Besoin d’aide ? Consultez l’assistance de votre logiciel de facturation électronique pour la gestion des clients, la prospection et la comptabilité.'
            }
          ]
        })
      }
    }
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.topics
  display grid
  gap 32px
  section
    padding-top 16px
    border-top 2px solid PUB_INK
  h2
    margin 0
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size 1.4rem
    line-height 1.2
  p
    margin 10px 0 0
    max-width 46ch
    color PUB_INK_SOFT
    font-family PUB_FONT_TEXT
    font-size 1rem
    line-height 1.6

// Les trois moyens de contact, sur une feuille
.contact
  box-sizing border-box
  max-width 640px
  margin-top 56px
  padding 22px 24px 8px
  background PUB_WHITE
  border 1px solid PUB_RULE
  border-top 4px solid PUB_LEMON
  border-radius 4px
  h2
    margin 0 0 8px
    padding-top 6px
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size 1.5rem
    line-height 1.2
  ul
    margin 0
    padding 0
    list-style none
  li
    display flex
    flex-wrap wrap
    align-items baseline
    justify-content space-between
    gap 4px 16px
    margin 0
    padding 14px 0
    border-top 1px solid PUB_RULE
    font-family PUB_FONT_TEXT
  .way
    color PUB_MUTED
    font-family PUB_FONT_TEXT
    font-size 0.95rem
  a
    font-family PUB_FONT_TEXT

@media (min-width: 800px)
  .topics
    grid-template-columns 1fr 1fr
    gap 40px 56px
</style>
